import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { OrderActions } from '../../../actions';
import Loader from '../../../components/Loader';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';
import OrderList from '../../../components/Orders/List';

class Inbound extends Component {
  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(OrderActions.getAllOrders());
  }

  scan = () => {
    browserHistory.push('/dispatcher/scan');
  }

  gotoManifests = () => {
    browserHistory.push('/dispatcher/manifests');
  }

  render() {
    const { orders } = this.props;
    const isAdmin = false;
    let content;
  
    if (!orders || orders.fetching || !orders.list) {
      content = <Loader />;
    } else {
      content = <OrderList dataProvider={orders.list} onRowSelection={this.selectRows} isAdmin={isAdmin} updateOrder={this.updateOrders} />
    }

    const subnavItems = [
      { key: 1, label: 'Scan', onClick: this.scan },
      { key: 2, label: 'Manifests', onClick: this.gotoManifests }
    ];

    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Inbound Management" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { orders } = state;
  return {
    orders
  }
}

export default connect(mapStateToProps)(Inbound);



// WEBPACK FOOTER //
// ./src/containers/Dispatcher/Inbound/index.js